export function toDataLinkName(area, category, link) {
    let linkName = '';
    if ('label' in link) {
        linkName = link.label.toLowerCase().replace(/\s+/g, '-');
    }
    else {
        linkName = (link.tooltip
            ? link.tooltip
            : link.url.substring(link.url.indexOf('//') + 2))
            .toLowerCase()
            .replace(/[\s./]/g, '-');
    }
    return `${area}.${category}.${linkName}`;
}
export const vDataLink = (el, binding) => {
    const { area, category, link } = binding.value;
    const dataLinkName = toDataLinkName(area, category, link);
    el.setAttribute('data-link-name', dataLinkName);
};
